module.exports = {
    application_key: "Application key",
    network_key: "Network key",
    echo: "Echo interval",
    alive: "Alive interval",
    power_scale: "Power scale",
    time_scale: "Time scale",
    active_channels: "Active channels",
    accuracy: "Accuracy",
    select_all: "Select all",
    new_test_profile: "New test profile",
    new_group: "New group",
    energy_offset: "Energy offset",
    transformation_ratio: "Transformation ratio",
    add_tag: "Add tag...",
    search: "Search",
    records_per_page: "Records per page",
    number_of_rows: "Number of rows",
    write_note: "Write note",
    value: "Value",
    security: "Security",
    IP_settings: "IP address setting",
    IP_address: "IP address",
    network_mask: "Network mask",
    gateway: "Gateway",
    active_power_threshold: "Active power threshold",
    map_name: "Map name",
    group_name: "Group name",
    device_select: "Device select",
    relay_select: "Relay select",
    notification_source: "Notification type",
    notification_destination: "Placement of notification"
}